export default "__VITE_ASSET__lY1OqJBL__"